export enum AggregationTypes {
  SECOND = 'SECOND',
  SECONDS10 = 'SECONDS10',
  MINUTE = 'MINUTE',
  MINUTES15 = 'MINUTES15',
  HOUR = 'HOUR',
  DAY = 'DAY',
  MONTH = 'MONTH'
}